import React, { Component } from 'react';
import { Nav, NavbarToggler, NavbarBrand, DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom'

import 'react-toastify/dist/ReactToastify.css';

import Lang from '../../languages';
import Config from '../../config';


class Header extends Component {
 constructor(props) {
  super(props);
  this.toggle = this.toggle.bind(this);
  this.state = {
   permissions: {
    "users": {}
   },
   dropdownOpen: {
    Language: false,
    User: false
   }
  };
 }

 toggle(dropdown) {
  var dropdownOpen = this.state.dropdownOpen;
  dropdownOpen[dropdown] = !dropdownOpen[dropdown];
  this.setState({ dropdownOpen });
 }

 sidebarToggle(e) {
  e.preventDefault();
  document.body.classList.toggle('sidebar-hidden');
 }

 sidebarMinimize(e) {
  e.preventDefault();
  document.body.classList.toggle('sidebar-minimized');
 }

 mobileSidebarToggle(e) {
  e.preventDefault();
  document.body.classList.toggle('sidebar-mobile-show');
 }


 render() {
  return (
   <header className="app-header navbar">
    <ToastContainer position="top-right" autoClose={2500} style={{ zIndex: 1999 }} />

    <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
     <span className="navbar-toggler-icon"></span>
    </NavbarToggler>
    <NavbarBrand></NavbarBrand>

    <span className="d-md-down-none"><a href={Config.siteURL} target="_blank" rel="noopener noreferrer">{Config.siteName}</a> | {Config.appName}</span>

    <Nav className="ml-auto" navbar>
     <Dropdown isOpen={this.state.dropdownOpen.Language} toggle={() => this.toggle('Language')} className="pr-3 mr-3 pb-1 border-right">
      <DropdownToggle nav>{Lang[this.props.session.language].languages[this.props.session.language]}</DropdownToggle>
      <DropdownMenu right>
       {
        Object.keys(Lang[this.props.session.language].languages).map((key, index) => {
         return (<DropdownItem key={index} value={key} onClick={() => this.props.changeLanguage(key)}>{Lang[this.props.session.language].languages[key]}</DropdownItem>)
        })
       }
      </DropdownMenu>
     </Dropdown>

     <Dropdown nav isOpen={this.state.dropdownOpen.User} toggle={() => this.toggle('User')}>
      <DropdownToggle nav>
       {this.props.session.user.name}
       <img src={'/images/avatar.png'} className="img-avatar" alt="" />
      </DropdownToggle>
      <DropdownMenu right>
       <DropdownItem><Link to="/profile" className="text-muted"><i className="fa fa-user"></i> {Lang[this.props.session.language].Users.titles.profile}</Link></DropdownItem>
       {
        this.props.session.permissions.users['administrators']
         ? <DropdownItem><Link to="/settings" className="text-muted"><i className="fa fa-wrench"></i> {Lang[this.props.session.language].Settings.title}</Link></DropdownItem>
         : null
       }

       <React.Fragment>
        {this.props.session.permissions.users ? Object.keys(this.props.session.permissions.users).map((userType, i) => (
         <DropdownItem key={i}><Link to={'/users/' + userType} className="text-muted"><i className="fa fa-user-md"></i> {Lang[this.props.session.language].Users.titles[userType]}</Link></DropdownItem>
        )) : (<div />)}
       </React.Fragment>

       <DropdownItem><Link to="/documentation" className="text-muted"><i className="fa fa-user"></i> {Lang[this.props.session.language].Documentation.title}</Link></DropdownItem>
       <DropdownItem onClick={this.props.getOut}><i className="fa fa-lock"></i> {Lang[this.props.session.language].Users.titles.disconnect}</DropdownItem>
      </DropdownMenu>
     </Dropdown>
    </Nav>
   </header>
  );
 }
}

export default Header;



// WEBPACK FOOTER //
// ./websources/containers/DefaultLayout/header.js